import benl from "./nl.json";
import nl from "./nl.json";
import fr from "./fr.json";
import en from "./en.json";
import de from "./de.json";
import lu from "./lu.json";

export const messages = {
    benl,
    nl,
    fr,
    en,
    de,
    lu
};